import withDraft from '@/utils/draftHelper';
import findResult, { removeItemByCode } from '@/utils/resultsHelper';
import { closeDatasetSettingsState, findAllDatasetSettings } from './state';
import actions from '../../constants';

const destroyDataset = withDraft((draft, { items }) => {
  findAllDatasetSettings(draft, { items }).forEach((category) => {
    items.forEach(({ code }) => {
      const item = findResult(draft.settings, category, code);
      if (item) {
        draft.settings[category].results = removeItemByCode(draft.settings[category].results, item);
      }
    });
  });
});

export default {
  [actions.DESTROY_DATASET]: destroyDataset,
  [actions.FINISH_DATASET_WIZARD]: closeDatasetSettingsState,
};
